import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/content";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      <div
        className={`transition-all duration-300 ${
          scrolled ? "bg-background-50/95 backdrop-blur shadow-[0_1px_0_0_oklch(var(--background-200))]" : "bg-transparent"
        }`}
      >
        <nav className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-4 md:px-6">
          <a href="#top" className="flex items-center gap-2">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-primary-400 to-accent-400 text-xl text-white">
              <i className="ri-heart-3-fill"></i>
            </span>
            <span className="font-display text-2xl text-foreground-900">吃瓜糖心</span>
          </a>

          <ul className="hidden items-center gap-1 lg:flex">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="whitespace-nowrap rounded-full px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>

          <div className="hidden items-center gap-3 lg:flex">
            <button className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-secondary-100 text-secondary-800 transition-colors hover:bg-secondary-200">
              <i className="ri-search-line text-lg"></i>
            </button>
            <a
              href="#subscribe"
              className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm text-white transition-colors hover:bg-primary-600"
            >
              订阅糖分
            </a>
          </div>

          <button
            onClick={() => setOpen(!open)}
            aria-label="打开菜单"
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg bg-secondary-100 text-secondary-800 lg:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
          </button>
        </nav>

        {open && (
          <div className="border-t border-background-200 bg-background-50 px-4 py-4 lg:hidden">
            <ul className="grid grid-cols-2 gap-2">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={() => setOpen(false)}
                    className="block rounded-lg bg-background-100 px-4 py-3 text-sm text-foreground-800 transition-colors hover:bg-primary-100 hover:text-primary-700"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </header>
  );
}